import React from "react";

import ErrorCaught from "src/shared/components/ErrorCaught";

import * as S from "./styled";

const ErrorState = () => (
  <S.FullSizeContainer>
    <ErrorCaught>
      <S.Text>This contact form won&apos;t load. Please try again.</S.Text>
    </ErrorCaught>
  </S.FullSizeContainer>
);

export default ErrorState;
